const insertWidget = () => {
  const widgetRoot = document.querySelector('#sidebar-custom-widget');

  if (widgetRoot) {
    const template = document.createElement('template');
    template.innerHTML = widgetRoot.textContent.trim();
    widgetRoot.textContent = '';
    widgetRoot.appendChild(template.content);
  }
};

export { insertWidget };
